import styled from 'styled-components'
import { TypeDiscovery, TypeFiesta } from '@at/design-system-foundation'

export const LeasingModalTitle = styled(TypeDiscovery)`
    font-size: 24px;
    font-variation-settings: 'wght' 400;
    color: ${({ theme }) => theme.color.text.title};
`
export const LeasingModalSubtitle = styled(TypeFiesta)`
    margin-top: 16px;
    font-size: 18px;
    font-variation-settings: 'wght' 500;
    color: ${({ theme }) => theme.color.text.default};
`
export const LeasingModalParagraph = styled(TypeFiesta)`
    font-size: 16px;
    font-variation-settings: 'wght' 400;
    color: ${({ theme }) => theme.color.text.default};
    margin-top: 8px;
`

export const LeasingBoldText = styled(TypeFiesta)`
    font-variation-settings: 'wght' 500;
    color: ${({ theme }) => theme.color.text.default};
    margin-top: 15px;
`
